/** Known-good DEX logos (local assets + CDN + official favicons). */
const SWITCH_LOGO = "/dex/switch.png";

const DEX_LOGO_BY_ID: Record<string, string> = {
  pulsex: "https://icons.llamao.fi/icons/protocols/pulsex",
  "pulsex-v1": "https://icons.llamao.fi/icons/protocols/pulsex",
  "pulsex-v2": "https://icons.llamao.fi/icons/protocols/pulsex",
  switch: SWITCH_LOGO,
  switchx: SWITCH_LOGO,
  "switch-x": SWITCH_LOGO,  uniswap: "https://icons.llamao.fi/icons/protocols/uniswap",
  "uniswap-v2": "https://icons.llamao.fi/icons/protocols/uniswap",
  "uniswap-v3": "https://icons.llamao.fi/icons/protocols/uniswap",
  "9mm": "https://icons.llamao.fi/icons/protocols/9mm",
  "liberty-swap": "https://libertyswap.finance/favicon.ico",
  sushiswap: "https://icons.llamao.fi/icons/protocols/sushiswap",
  pancakeswap: "https://icons.llamao.fi/icons/protocols/pancakeswap",
};

/** Official sites for favicon fallback when pool links go via DexScreener. */
const DEX_SITE_BY_ID: Record<string, string> = {
  pulsex: "https://app.pulsex.com",
  switchx: "https://beta.switch.win",
  "liberty-swap": "https://libertyswap.finance",
  uniswap: "https://app.uniswap.org",
  "9mm": "https://9mm.pro",
};

function normalizeDexId(dexId: string) {
  return dexId.toLowerCase().trim();
}

/** Favicon from the DEX site (not DexScreener wrapper links). */
export function dexLogoFromPoolUrl(
  poolUrl: string,
  dexId?: string,
): string | null {
  const origins: string[] = [];

  if (dexId) {
    const id = normalizeDexId(dexId);
    if (DEX_SITE_BY_ID[id]) origins.push(DEX_SITE_BY_ID[id]);
    const base = id.replace(/-v\d+$/, "");
    if (DEX_SITE_BY_ID[base]) origins.push(DEX_SITE_BY_ID[base]);
  }

  try {
    const origin = new URL(poolUrl).origin;
    if (!origin.includes("dexscreener.com")) {
      origins.unshift(origin);
    }
  } catch {
    /* ignore */
  }

  const site = origins[0];
  if (!site) return null;

  return `https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${encodeURIComponent(site)}&size=64`;
}

export function resolveDexLogoSources(dexId: string, poolUrl: string): string[] {
  const id = normalizeDexId(dexId);
  const sources: string[] = [];

  const direct = DEX_LOGO_BY_ID[id];
  if (direct) sources.push(direct);

  const base = id.replace(/-v\d+$/, "");
  if (base !== id && DEX_LOGO_BY_ID[base]) {
    sources.push(DEX_LOGO_BY_ID[base]);
  }

  if (!direct && !DEX_LOGO_BY_ID[base]) {
    sources.push(`https://icons.llamao.fi/icons/protocols/${id}`);
    if (base !== id) {
      sources.push(`https://icons.llamao.fi/icons/protocols/${base}`);
    }
  }

  const fromPool = dexLogoFromPoolUrl(poolUrl, dexId);
  if (fromPool && !sources.includes(fromPool)) {
    sources.push(fromPool);
  }

  return sources;
}

export function resolveDexLogo(dexId: string, poolUrl: string): string {
  return (
    resolveDexLogoSources(dexId, poolUrl)[0] ??
    dexLogoFromPoolUrl(poolUrl, dexId) ??
    ""
  );
}
